// Redux slice for managing material match summary loading, data, and errors
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { MaterialMatchSummary } from '../utils/match-maker.types';
import { getMaterialMatchSummary } from './material-match-summary.thunk';

// State shape for the material match summary feature
interface MaterialMatchSummaryState {
  loading: boolean;
  materialMatchSummaryData?: MaterialMatchSummary; // Replace with actual data type
  error?: string | null;
}

// Initial state for the material match summary slice
const initialState: MaterialMatchSummaryState = {
  loading: false,
  materialMatchSummaryData: undefined,
  error: null,
};

// Slice for the material match summary feature with reducers and extraReducers for async actions
const materialMatchSummarySlice = createSlice({
  name: 'materialMatchSummary',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
  extraReducers: builder => {
    builder
      // Handle getMaterialMatchSummary pending state
      .addCase(getMaterialMatchSummary.pending, state => {
        state.loading = true;
        state.error = null;
      })

      // Handle getMaterialMatchSummary fulfilled state
      .addCase(
        getMaterialMatchSummary.fulfilled,
        (state, action: PayloadAction<MaterialMatchSummary>) => {
          state.materialMatchSummaryData = action.payload;
          state.loading = false;
        }
      )

      // Handle getMaterialMatchSummary rejected state
      .addCase(getMaterialMatchSummary.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

// Export reducer for store
export default materialMatchSummarySlice.reducer;
